import moment from 'moment';

import { luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// actions

const GET_REGIONS = 'luft/region/GET_REGIONS';
const GET_REGIONS_SUCCESS = 'luft/region/GET_REGIONS_SUCCESS';
const GET_REGIONS_FAILURE = 'luft/region/GET_REGIONS_FAILURE';

const GET_UFS = 'luft/region/GET_UFS';
const GET_UFS_SUCCESS = 'luft/region/GET_UFS_SUCCESS';
const GET_UFS_FAILURE = 'luft/region/GET_UFS_FAILURE';

// reducer

const initialState = {
  regions: {
    isFetching: false,
    error: '',
    requested: '',
    list: [],
  },
  ufs: {
    isFetching: false,
    error: '',
    requested: '',
    list: [],
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_REGIONS:
      return {
        ...state,
        regions: {
          ...state.regions,
          isFetching: true,
          error: '',
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
        },
      };

    case GET_REGIONS_SUCCESS:
      return {
        ...state,
        regions: {
          ...state.regions,
          isFetching: false,
          error: '',
          list: action.list,
        },
      };

    case GET_REGIONS_FAILURE:
      return {
        ...state,
        regions: {
          ...state.regions,
          isFetching: false,
          error: action.error,
        },
      };

    case GET_UFS:
      return {
        ...state,
        ufs: {
          ...state.ufs,
          isFetching: true,
          error: '',
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
        },
      };

    case GET_UFS_SUCCESS:
      return {
        ...state,
        ufs: {
          ...state.ufs,
          isFetching: false,
          error: '',
          list: action.list,
        },
      };

    case GET_UFS_FAILURE:
      return {
        ...state,
        ufs: {
          ...state.ufs,
          isFetching: false,
          error: action.error,
        },
      };

    default:
      return state;
  }
}

export default reducer;

// actions creators

function _getRegions() {
  return { type: GET_REGIONS };
}

function _getRegionsSuccess(list) {
  return {
    type: GET_REGIONS_SUCCESS,
    list,
  };
}

function _getRegionsFailure(error) {
  return {
    type: GET_REGIONS_FAILURE,
    error,
  };
}

function _getUfs() {
  return { type: GET_UFS };
}

function _getUfsSuccess(list) {
  return {
    type: GET_UFS_SUCCESS,
    list,
  };
}

function _getUfsFailure(error) {
  return {
    type: GET_UFS_FAILURE,
    error,
  };
}

// thunk action creators

export function getRegions() {
  return function (dispatch) {
    (async () => {
      dispatch(_getRegions());

      try {
        const response = await luftGet('/Region/GetAllRegions');
        dispatch(_getRegionsSuccess(response.data));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getRegionsFailure(error.message),
        );
      }
    })();
  };
}

export function getUfs() {
  return function (dispatch) {
    (async () => {
      dispatch(_getUfs());

      try {
        const response = await luftGet('/Region/GetAllStates');
        dispatch(_getUfsSuccess(response.data));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getUfsFailure(error.message),
        );
      }
    })();
  };
}
